import { OutsideClick } from '@cian/outside-click-component';
import { Popup, PopupArrow } from '@cian/popup-component';
import { IStyleConfig, mergeStyles } from '@cian/utils';
import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOfferHelper } from '../../../presenter';
import { IJsonQuery } from '../../../types/json-query';
import { IOffer, TAgentRating } from '../../../types/offer';
import { IconBlacklist, IconWhitelist } from './icons';

const style = require('./index.css');

export interface IUserInfoAPI {
  ratingBlockedAgents: number[];
  userIsAuthenticated: boolean;
  onAgentRatingChanged(offer: IOffer, rating: TAgentRating): void;
  onPopupOpen?(): void;
  onPopupClose?(): void;
}

export interface IUserInfoProps {
  content: React.ReactNode;
  avatar?: React.ReactNode | null;
  containerStyle?: IStyleConfig;
  userInfoStyle?: IStyleConfig;
  userInfoStyleAction?: IStyleConfig;
  isReverseOrder?: boolean;
}

export interface IUserInfoState {
  isPopupVisible: boolean;
}

export interface IUserInfoPopupContext {
  baseUrl: string;
  jsonQuery: IJsonQuery;
  offer: IOffer;
  offerHelper: IOfferHelper;

  api: { userInfo: IUserInfoAPI; };
}

export class UserInfoPopup extends React.Component<IUserInfoProps, IUserInfoState> {
  public state = {
    isPopupVisible: false,
  };

  public context: IUserInfoPopupContext;

  public static contextTypes = {
    api: PropTypes.object,
    baseUrl: PropTypes.string,
    jsonQuery: PropTypes.object,
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
  };

  public componentDidUpdate(prevProps: IUserInfoProps, prevState: IUserInfoState) {
    if (prevState.isPopupVisible !== this.state.isPopupVisible) {
      if (this.state.isPopupVisible) {
        if (this.context.api.userInfo.onPopupOpen) {
          this.context.api.userInfo.onPopupOpen();
        }
      } else {
        if (this.context.api.userInfo.onPopupClose) {
          this.context.api.userInfo.onPopupClose();
        }
      }
    }
  }

  public render () {
    const {
      userIsAuthenticated,
    } = this.context.api.userInfo;
    const {
      avatar,
      content,
      userInfoStyle,
      userInfoStyleAction,
      isReverseOrder,
    } = this.props;
    const { isPopupVisible } = this.state;

    const offer = this.context.offerHelper;

    const userPersonalRating = offer.presenters.getUserPersonalRating();
    const userId = offer.presenters.getCianUserId();

    return (
      <div {...mergeStyles([
        style['container'],
        isReverseOrder && style['container-reverse'],
        this.props.containerStyle,
      ])}>
        <OutsideClick
          rootElement={<div />}
          onOutsideClick={this.handleOutsideClick}
        >
          <div
            {...mergeStyles([
              style['user_info'],
              isPopupVisible && style['user_info--active'],
              userInfoStyle,
              isPopupVisible && userInfoStyleAction,
            ])}
            onClick={this.handleInfoClick}
          >
            {content}
          </div>
          {isPopupVisible && <Popup arrow={PopupArrow.RIGHT}
            containerStyle={style['popup']}
          >
            { isReverseOrder && this.renderLink(userId) }
            { isReverseOrder && userIsAuthenticated && <hr className={style['delimiter']} /> }
            { userIsAuthenticated && <ul className={style['links']}>
              <li className={style['links-link']}>
                <a
                  className={style['link-item']}
                  href="#"
                  onClick={(event) =>
                    this.handleListClick(event, userPersonalRating !== 'negative' ? 'negative' : 'neutral')}
                >
                  <IconBlacklist isActive={userPersonalRating === 'negative'} />
                  {userPersonalRating !== 'negative' ? 'В чёрный список' : 'Убрать из чёрного списка'}
                </a>
              </li>
              <li className={style['links-link']}>
                <a
                  className={style['link-item']}
                  href="#"
                  onClick={(event) =>
                    this.handleListClick(event, userPersonalRating !== 'positive' ? 'positive' : 'neutral')}
                >
                  <IconWhitelist isActive={userPersonalRating === 'positive'} />
                  {userPersonalRating !== 'positive' ? 'В белый список' : 'Убрать из белого списка'}
                </a>
              </li>
            </ul>}
            { !isReverseOrder && userIsAuthenticated && <hr className={style['delimiter']} /> }
            { !isReverseOrder && this.renderLink(userId) }
          </Popup>}
        </OutsideClick>
        {avatar}
      </div>
    );
  }

  private renderLink(userId: number | string | undefined) {
    const { isReverseOrder } = this.props;
    const { baseUrl, offer } = this.context;
    const userQuery = userId ? `id_user=${userId}&` : '';
    const offerTypeForUserUrl: string =  offer.offerType === 'commercial' ? 'offices' : offer.offerType;
    const profileUri = offer && offer.user && offer.user.profileUri;

    return (
      <div className={style['all_offers']}>
        { isReverseOrder && profileUri && (
          <a className={style['offer-link']} target="_blank" href={`${baseUrl || ''}${profileUri}`}>Профиль агента</a>
        )}
        <a
          className={style['offer-link']}
          href={`/cat.php?${userQuery}deal_type=${offer.dealType}&${offerTypeForUserUrl}=yes&engine_version=2`}
          target="_blank">Все объявления агента</a>
      </div>
    );
  }

  private handleListClick = (event: React.MouseEvent<HTMLAnchorElement>, rating: TAgentRating) => {
    event.preventDefault();

    this.context.api.userInfo.onAgentRatingChanged(this.context.offer, rating);
  }

  private handleInfoClick = () => {
    this.setState({
      isPopupVisible: !this.state.isPopupVisible,
    });
  }

  private handleOutsideClick = () => {
    if (!this.state.isPopupVisible) {
      return;
    }

    this.setState({
      isPopupVisible: false,
    });
  }
}
